import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  Edit,
  FormTab,
  List,
  NumberInput,
  SearchInput,
  TextField,
} from "react-admin";
import { useCommonLabels } from "../i18n/hooks";
import { FormSection } from "../ui/forms/FormSection";
import { BodyLangFields, TitleLangFields } from "../ui/forms/langFields";
import { LangTabbedForm } from "../ui/forms/LangTabbedForm";

const filters = [<SearchInput key="q" source="q" alwaysOn />];

const htmlHelper =
  "Заголовки H2/H3, абзацы, списки, жирный текст, ссылки — как в мобильном приложении.";

const PhAboutForm = () => {
  const c = useCommonLabels();
  return (
    <LangTabbedForm>
      <FormTab label="Общее">
        <FormSection title="Настройки">
          <NumberInput source="SortOrder" label="Порядок" defaultValue={0} fullWidth />
          <BooleanInput source="Active" label={c.active} defaultValue />
        </FormSection>
      </FormTab>
      <FormTab label="🇦🇿 AZ">
        <TitleLangFields lang="AZ" titleRequired />
        <BodyLangFields lang="AZ" rich bodyRequired helperText={htmlHelper} />
      </FormTab>
      <FormTab label="🇷🇺 RU">
        <TitleLangFields lang="RU" titleRequired />
        <BodyLangFields lang="RU" rich bodyRequired helperText={htmlHelper} />
      </FormTab>
      <FormTab label="🇬🇧 EN">
        <TitleLangFields lang="EN" titleRequired />
        <BodyLangFields lang="EN" rich bodyRequired helperText={htmlHelper} />
      </FormTab>
    </LangTabbedForm>
  );
};

export const PhAboutList = () => {
  const c = useCommonLabels();
  return (
    <List filters={filters} sort={{ field: "SortOrder", order: "DESC" }}>
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="Id" label="ID" />
        <TextField source="TitleRU" label="Заголовок" />
        <BooleanField source="Active" label={c.status} />
      </Datagrid>
    </List>
  );
};

export const PhAboutEdit = () => (
  <Edit mutationMode="pessimistic">
    <PhAboutForm />
  </Edit>
);

export const PhAboutCreate = () => (
  <Create>
    <PhAboutForm />
  </Create>
);
